import { render, staticRenderFns } from "./communityApplicationMessage.vue?vue&type=template&id=4e959cb2&scoped=true"
import script from "./communityApplicationMessage.vue?vue&type=script&lang=js"
export * from "./communityApplicationMessage.vue?vue&type=script&lang=js"
import style0 from "./communityApplicationMessage.vue?vue&type=style&index=0&id=4e959cb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e959cb2",
  null
  
)

export default component.exports